module.exports = __webpack_public_path__ + "static/media/logo2.bf9a7ff8.png";